import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g fill="none" data-name="Layer 2">
        <path d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g
          stroke="#424242"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          data-name="Group 52"
        >
          <rect
            width="29.59"
            height="29.59"
            x="60.2"
            y="40.2"
            data-name="Rectangle 51"
            rx="5"
          />
          <path d="M65.96 35.27V28.7" data-name="Line 7" />
          <path d="M84.04 35.27V28.7" data-name="Line 8" />
          <path d="M75 35.27V28.7" data-name="Line 9" />
          <path d="M65.96 81.3v-6.57" data-name="Line 10" />
          <path d="M84.04 81.3v-6.57" data-name="Line 11" />
          <path d="M75 81.3v-6.57" data-name="Line 12" />
          <path d="M94.73 45.96h6.57" data-name="Line 13" />
          <path d="M94.73 64.04h6.57" data-name="Line 14" />
          <path d="M94.73 55h6.57" data-name="Line 15" />
          <path d="M48.7 45.96h6.57" data-name="Line 16" />
          <path d="M48.7 64.04h6.57" data-name="Line 17" />
          <path d="M48.7 55h6.57" data-name="Line 18" />
        </g>
      </g>
    </svg>
  );
}

export default Icon;
